import type React from 'react';
import { FormField, FormHelp, Label } from '@zillow/constellation-10';

import type { Field } from '../../../../models';
import CurrencyInput from '../../../Widgets/CurrencyInput';

type Props = {
  label: string;
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  onBlur: (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  field: Field;
  dataFieldName: string;
  perMonth: boolean;
  formHelp?: string;
};

export default function PetsCurrencyInput({ label, field, dataFieldName, perMonth, formHelp, ...rest }: Props) {
  return (
    <FormField
      required
      label={<Label>{label}</Label>}
      error={field.hasError}
      control={
        <CurrencyInput {...rest} data-field-name={dataFieldName} endAdornment={perMonth ? 'per month' : undefined} />
      }
      description={
        <>
          {formHelp && !field.hasError && <FormHelp>{formHelp}</FormHelp>}
          {field.hasError && <FormHelp>{field.getErrorMessage()}</FormHelp>}
        </>
      }
    />
  );
}
